module.exports = __webpack_public_path__ + "static/media/organize-the-squares.a9bfcad1.mov";